import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-shared-help-dialog',
  templateUrl: './shared-help-dialog.component.html',
  styleUrls: ['./shared-help-dialog.component.scss'],
})
export class SharedHelpDialogComponent {
  constructor(private dialog_ref: MatDialogRef<SharedHelpDialogComponent>, @Inject(MAT_DIALOG_DATA) data: any) {}

  onCloseClick(): void {
    this.dialog_ref.close();
  }
}
